import ClickTile from './ClickableTile';

export default ClickTile;
